import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { APP_ICONS } from '../../icons/app-icons';

@Component({
  selector: 'app-register-options',
  templateUrl: './register-options.component.html',
  styleUrls: ['./register-options.component.scss'],
  standalone: false
})
export class RegisterOptionsComponent {
  @Input() slug!: string;
  @Output() continueWithEmail = new EventEmitter<void>();
  
  iconGoogle = APP_ICONS.google;
  private readonly doc = inject(DOCUMENT) as Document;

  registerWithGoogle() {
    const api = environment.apis.default.url;
    const returnUrl = `${environment.application.baseUrl}/auth/google-callback`;
    const sommelierSlug = this.slug || '';

    let url = `${api}/external/register-google?returnUrl=${encodeURIComponent(returnUrl)}`;
    if (sommelierSlug) {
      url += `&sommelierSlug=${encodeURIComponent(sommelierSlug)}`;
    }

    this.doc.location.href = url;
  }

  onContinueWithEmail() {
    this.continueWithEmail.emit();
  }
}
